import { useNavigate } from 'react-router-dom'

import ChevronRightIcon from '@/assets/icons/icon-chevron-right.svg'
import { Page } from '@/components/layout/page/page.tsx'
import { Button } from '@/components/ui/button.tsx'
import { Separator } from '@/components/ui/separator.tsx'
import { Switch } from '@/components/ui/switch.tsx'
import { useRestrictedWordsSettings } from '@/modules/restricted-words/hooks/use-restricted-words-settings.ts'
import { useToggleRestrictedWords } from '@/modules/restricted-words/hooks/use-toggle-restricted-words.ts'
import { RestrictedWordsSettings } from '@/modules/restricted-words/ui/restricted-words-settings.tsx'
import { RestrictedWords } from '@/modules/restricted-words/ui/restricted-words.tsx'
import { classNames } from '@/utils/helpers.ts'

export const RestrictedWordsView = () => {
  const navigate = useNavigate()
  const {
    isRestrictedWordsSettingsLoading,
    settings,
    isRestrictedWordsSettingsFetching,
  } = useRestrictedWordsSettings()
  const { toggleRestrictedWords, isLoading: isToggleLoading } =
    useToggleRestrictedWords()
  const isFetchingSettings =
    isRestrictedWordsSettingsLoading || isRestrictedWordsSettingsFetching
  const handleLogsClick = () => {
    navigate('/blacklisted-words/logs')
  }

  return (
    <Page
      title="Blacklisted Words"
      description="This feature is designed to protect your accounts from prohibited messages."
      headerOptions={
        <div className="flex items-center">
          <p className="mr-2 text-sm font-medium text-title">Activate</p>
          <Switch
            className={classNames({
              'cursor-not-allowed opacity-50':
                isToggleLoading || isFetchingSettings,
            })}
            checked={settings?.enabled}
            onCheckedChange={toggleRestrictedWords}
            disabled={isToggleLoading || isFetchingSettings}
          />
        </div>
      }
    >
      {settings?.enabled && (
        <>
          <Separator className="mb-5" />
          <div>
            <h4 className="text-xl font-semibold">Restrictions</h4>
            <p className="mt-1 text-sm text-text-sub">
              As with all automatic restrictions, these will not work if someone
              is actively trying to bypass them. But they will still help you
              get notified about bad actors before they try to bypass the
              systems.
            </p>
            <RestrictedWordsSettings />
          </div>

          <Separator className="my-5" />

          <div className="flex items-center justify-between">
            <h4 className="text-xl font-semibold">Blocked Messages Log</h4>
            <Button
              variant="ghost"
              className="flex items-center"
              onClick={handleLogsClick}
            >
              View Messages Log <ChevronRightIcon />
            </Button>
          </div>

          <Separator className="my-5" />

          <div>
            <h4 className="mb-4 text-xl font-semibold">Blacklisted Words</h4>
            <RestrictedWords />
          </div>
        </>
      )}
    </Page>
  )
}
